(() => {
    /*
    controller-as syntax for uibModal requires different setup
    see: https://github.com/angular-ui/bootstrap/blob/master/src/modal/docs/readme.md
    so if you're going to convert it, consult the above and make sure to modify caller(s)
     */
    function PreviewModalController(
        $scope,
        $sce,
        $uibModalInstance,
        $timeout,
        messageType,
        message
    ) {
        this.$scope = $scope;
        this.$sce = $sce;
        this.$uibModalInstance = $uibModalInstance;
        this.$timeout = $timeout;
        this.messageType = messageType;
        this.message = message;
        setupFunctionsOn(this);
    }

    function setupFunctionsOn($ctrl) {
        $ctrl.$onInit = function () {
            $ctrl.$scope.CampaignTemplateCommunicationTypes = Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes;
            $ctrl.$scope.messageType = $ctrl.messageType;
            $ctrl.$scope.message = $ctrl.message;
            if ($ctrl.messageType === $ctrl.$scope.CampaignTemplateCommunicationTypes.inbox) {
                // HACK ALERT: the iframe hasn't been rendered at this point
                // -> delay the manual set of content until angular
                //    has finished the current digest cycle
                // -> this is not pretty, but other methods I've tried failed:
                //      - including setting src on the iframe
                //          - when set as template string, it remains undefined
                //          - when using ng-src bound onto a property of the controller,
                //              the user is presented with the option to download the content
                //              even though the content type is set in the url to text/html
                eventuallyDo(
                    () => !!document.querySelector("iframe#inbox-preview"),
                    () => {
                        const
                            trusted = $ctrl.$sce.trustAsHtml($ctrl.message),
                            trustedContent = typeof trusted === "string"
                                ? trusted
                                : trusted.$$unwrapTrustedValue();
                        const target = document.querySelector("iframe#inbox-preview");
                        target.src = `data:text/html;charset=utf-8,${encodeURIComponent(trustedContent)}`
                    });
            }
        };

        $ctrl.$scope.close = function () {
            $ctrl.$uibModalInstance.close();
        };
    }

    function eventuallyDo(
        condition,
        action
    ) {
        if (condition()) {
            action();
            return;
        }
        window.setTimeout(() => eventuallyDo(condition, action), 100);
    }

    class PreviewCommunication {
        messageType;
        message;
        $uibModalInstance;

        constructor(
            $scope,
            $sce,
            $uibModalInstance,
            $timeout,
        ) {
            this.$scope = $scope;
            this.$sce = $sce;
            this.$uibModalInstance = $uibModalInstance;
            this.$timeout = $timeout;
            setupFunctionsOn(this);
        }
    }

    angular
        .module("dashboard")
        .controller("PreviewModalController", [
            "$scope",
            "$sce",
            "$uibModalInstance",
            "$timeout",
            "messageType",
            "message",
            PreviewModalController
        ]);

    // component to be used from tests only
    // -> wraps up the same logic, but as a
    //    standalone component, instead of
    //    being hosted in $uibModal
    angular.module("dashboard")
        .component("testPreviewCommunication", {
            templateUrl: "components/campaigndesigner/managecampaigntemplates/commssetup/preview.a57bac9e.html",
            bindings: {
                messageType: "<",
                message: "<"
            },
            controller: [
                "$scope",
                "$sce",
                "$uibModal",
                "$timeout",
                PreviewCommunication
            ]
        });
})();
